// Format an average response time (seconds) into a human-readable string.
//
// Port of faQt's frontend/src/utils.js → formatResponseTime, kept identical
// so behaviour is consistent across the platform.
//
//   -1 / null / undefined → "2 hours" (default copy when no data yet)
//   <= 15 minutes        → "15 minutes"
//   <= 30 minutes        → "30 minutes"
//   <= 60 minutes        → "1 hour"
//   <= 2 hours           → "2 hours"
//   <= 24 hours          → "{n} hour(s)"
//   <= 7 days            → "{n} day(s)"
//   <= 4 weeks           → "{n} week(s)"
//   otherwise            → "{n} month(s)"
//
// Returns the trailing piece (e.g. "15 minutes") — the consumer prepends
// "Usually replies within ".
export const formatResponseTime = (responseTimeSeconds) => {
  if (
    responseTimeSeconds === null ||
    responseTimeSeconds === undefined ||
    responseTimeSeconds === -1
  ) {
    return "2 hours";
  }

  const minutes = responseTimeSeconds / 60;
  const hours = minutes / 60;
  const days = hours / 24;
  const weeks = days / 7;

  if (minutes <= 15) return "15 minutes";
  if (minutes <= 30) return "30 minutes";
  if (minutes <= 60) return "1 hour";
  if (hours <= 2) return "2 hours";
  if (hours <= 24) {
    const n = Math.round(hours);
    return `${n} ${n === 1 ? "hour" : "hours"}`;
  }
  if (days <= 7) {
    const n = Math.round(days);
    return `${n} ${n === 1 ? "day" : "days"}`;
  }
  if (weeks <= 4) {
    const n = Math.round(weeks);
    return `${n} ${n === 1 ? "week" : "weeks"}`;
  }
  const months = Math.round(weeks / 4);
  return `${months} ${months === 1 ? "month" : "months"}`;
};
